import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalFooterComponent } from './modal-footer.component';
import { StackModule } from '../stack/stack.module'
@NgModule({
  declarations: [ModalFooterComponent],
  imports: [CommonModule, StackModule],
  exports: [ModalFooterComponent],
})
export class ModalFooterModule {}
